module.exports = __webpack_public_path__ + "static/media/faculty.03792d01.svg";